"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// todo: this file is in a transitional state - be sure to clean up at end of styleguide overhaul
var baseColorThemes = [undefined, 'primary', // primaryGhost - clickable
'cta', // ctaGhost - clickable
// pseudo - clickable
// overDark - text
'info', 'warning', 'danger'];
var _default = baseColorThemes;
exports.default = _default;